module.exports = __webpack_public_path__ + "static/media/payment-icon-googlepay.7ae95960.svg";